// Constants for different requests for current reducer
export default {
  task: 'TASK',
  tasks: 'TASKS',
};
